<script setup lang="ts">

import { TagLine } from "@components/TagLine";

</script>

<template>

    <div class="max-w-5xl mx-auto text-center tracking-wider pt-8 pb-16 md:pt-16 px-4">

        <v-carousel :show-arrows="false"
                    class="!h-auto min-h-[180px]"
                    hide-delimiters
                    cycle>

            <v-carousel-item>
                <div class="py-4">
                    <div class="text-4xl md:text-6xl font-semibold">
                        Keeps your car <span class="text-primary-600 uppercase font-bold">Healthy</span>
                    </div>
                    <div class="text-4xl md:text-6xl font-semibold mt-4">
                        and your wallet <span class="text-primary-600 uppercase font-bold">Happy!</span>
                    </div>
                </div>
            </v-carousel-item>

            <v-carousel-item>
                <div class="py-4">
                    <div class="text-4xl md:text-5xl font-semibold">
                        Like a <span class="text-primary-600 uppercase font-bold">Fitbit</span> for your car
                    </div>
                    <div class="text-4xl md:text-5xl font-semibold mt-4">
                        that puts <span class="text-primary-600 uppercase font-bold">money</span> in your pocket
                    </div>
                </div>
            </v-carousel-item>
            
            <v-carousel-item>
                <div class="py-4">
                    <div class="text-4xl md:text-5xl font-semibold">
                        Eliminate's big bills for your
                    </div>
                    <div class="text-4xl md:text-5xl font-semibold mt-4">
                        <span class="text-primary-600 uppercase font-bold">Battery, Tyres, Brakes &amp; Wipers</span>
                    </div>
                </div>
            </v-carousel-item>
            
            <v-carousel-item>
                <div class="py-4">
                    <div class="text-4xl md:text-5xl font-semibold">
                        Pays for your <span class="text-primary-600 uppercase font-bold">Tyres &amp; Service</span>
                    </div>
                    <div class="text-3xl md:text-5xl font-semibold mt-4">
                        every time you 
                        <span class="text-primary-600 uppercase font-bold">
                            eat out or eat in
                            <Icon name="food" />
                        </span>
                    </div>
                </div>
            </v-carousel-item>
            
        </v-carousel>

        <TagLine />

    </div>

</template>